/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

$(function () {
  $('.js-service-item').hide()
  $('.service1').show()
  $('.js-service-btn').click(function () {
    $('.js-service-btn').removeClass('current')
    $(this).addClass('current')
    $('.js-service-item').hide()
    let href = $(this).attr('href')
    $('.' + href).show()
    return false
  })
})

if (window.matchMedia('(max-width:768px)').matches) {
  $(function () {
    $('.js-news-item').hide()
    $('.news1').show()
    $('.js-news-btn').click(function () {
      $('.js-news-btn').removeClass('current')
      $(this).addClass('current')
      $('.js-news-item').hide()
      let href = $(this).attr('href')
      $('.' + href).show()
      return false
    })
  })
}

if (document.getElementsByClassName('js-mv-bg')[0]) {
  // MV背景側
  const mvSwiperBg = new Swiper('.js-mv-bg', {
    speed: 3000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  })

  // MV右側　背景側の連動で動かす
  const mvSwiperFront = new Swiper('.js-mv-front', {
    speed: 3000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    slidesPerView: 1,
    loop: true,
  })

  mvSwiperBg.on('slideChangeTransitionStart', function () {
    // let time
    // if (mvSwiperBg.isEnd) {
    //   time = 1500
    // } else {
    //   time = 1500
    // }

    // スライド時のトリガー
    // 下側のスライドを時間差で動かす
    setTimeout(() => {
      mvSwiperFront.slideNext()
    }, 1500)
  })
}

const swiper = new Swiper('.swiper', {
  spaceBetween: 40,
  loop: true,
  // ページネーションが必要なら追加
  pagination: {
    el: '.swiper-pagination',
  },
})
$(function () {
  //.accordion_oneの中の.accordion_headerがクリックされたら
  $('.js-toggle').click(function () {
    $(this).toggleClass('no-br')
    $(this).next('.js-toggleBox__inner').slideToggle()
    $(this).toggleClass('open')
  })
})

$('.acc-btn').click(function () {
  $(this).next('.acc-body').toggleClass('active')
})

$(function () {
  // MW formのブラウザバック対策
  if ($('#confirm').length) {
    history.pushState(null, null, null) // 空の履歴を入れてブラウザバック無効化
    //ブラウザバックボタン押下時
    window.addEventListener('popstate', function (e) {
      history.pushState(null, null, null)
      document.querySelector('[name="submitBack"]').click() // フォーム内の戻るボタンを押す
    })
  }
})
